import { actorDataExportSchema, type ActorDataExport } from "#actor-data-export-schema";
import type { ActorRawDatabaseHandle } from "@-/dev.improve.haniverse.database.actor";
import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";

export async function createActorDataExport(
  actorDatabase: ActorRawDatabaseHandle,
  exportedAt = new Date(),
): Promise<ActorDataExport> {
  const tables = await actorDatabase.transaction(async (transaction) => ({
    collection: await transaction.select().from(actorSchema.collection),
    collectionMorpheme: await transaction.select().from(actorSchema.collectionMorpheme),
    fsrsCard: await transaction.select().from(actorSchema.fsrsCard),
    fsrsCardReviewLog: await transaction.select().from(actorSchema.fsrsCardReviewLog),
    morphemeNote: await transaction.select().from(actorSchema.morphemeNote),
    morphemeSearchVisit: await transaction.select().from(actorSchema.morphemeSearchVisit),
    rewardClaim: await transaction.select().from(actorSchema.rewardClaim),
    studySession: await transaction.select().from(actorSchema.studySession),
    travelTrip: await transaction.select().from(actorSchema.travelTrip),
    user: await transaction.select().from(actorSchema.user),
    userCard: await transaction.select().from(actorSchema.userCard),
    userCardReview: await transaction.select().from(actorSchema.userCardReview),
    userGraphemeMeaningCard: await transaction.select().from(actorSchema.userGraphemeMeaningCard),
    userGraphemePronunciationCard: await transaction
      .select()
      .from(actorSchema.userGraphemePronunciationCard),
    userQuest: await transaction.select().from(actorSchema.userQuest),
    userQuizCard: await transaction.select().from(actorSchema.userQuizCard),
    userSentence: await transaction.select().from(actorSchema.userSentence),
    userSlide: await transaction.select().from(actorSchema.userSlide),
    userWord: await transaction.select().from(actorSchema.userWord),
    userWordSentenceCard: await transaction.select().from(actorSchema.userWordSentenceCard),
  }));

  return actorDataExportSchema.parse({
    exportedAt: exportedAt.toISOString(),
    format: "han-data-export",
    formatVersion: 1,
    tables,
  });
}
